export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.47 3.415a.75.75 0 01.258.767l-4 16a.75.75 0 01-.728.568.907.907 0 01-.313-.06h-.003a1.76 1.76 0 01-.158-.07 5.546 5.546 0 01-.33-.18 27.796 27.796 0 01-.96-.59 139.17 139.17 0 01-2.429-1.597L9.53 20.53A.75.75 0 018.25 20v-4.158a740.657 740.657 0 01-4.678-3.226.75.75 0 01.093-1.287l16-8a.75.75 0 01.804.086zM9.75 16.865v1.324l.79-.79-.79-.534zm-4.283-4.76c1.03.713 2.221 1.535 3.432 2.364l7.548-7.854-10.98 5.49zM18.589 6.55l-8.434 8.777c.678.46 1.345.912 1.977 1.337 1.136.764 2.155 1.439 2.91 1.92.17.11.326.207.466.294L18.588 6.55z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};